export default __webpack_public_path__ + "curve2.png";